import Vue from 'vue'
import watermark from '@dp/watermark'
import Router from 'vue-router'

import App from './App.vue'
import store from './store/index'
import api from './utils/api'

import './utils/moment-setup'

import '@ss/mtd-vue/lib/theme2/index.css'
import MTD from '@ss/mtd-vue'
import VueClipboard from 'vue-clipboard2'
import {Select} from 'element-ui'
import '@ss/mtd-vue-mobile/lib/styles/index.css'
import MTDM from '@ss/mtd-vue-mobile'

Vue.use(MTDM);
Vue.use(Router);
Vue.use(VueClipboard);
Vue.use(MTD);

// element-ui
Vue.use(Select);

Vue.config.productionTip = false;

if (process.env.NODE_ENV !== 'development') {
  // 增加水印
  watermark(document.body, {
    backgroundColor: '#f2f4f9',
    urlPrefix: '/api-wm'
  })
} else {
  // $handleError pollyfill
  Vue.prototype.$handleError = (error, extra, ...args) => {
    console.log(error, extra, ...args)
  }
}

api.get('/api/client_sso_auth').then((_response) => {
  // 处理成功情况
  store.dispatch('build_router').then((routes) => {
    new Vue({
      router: new Router({
        routes
      }),
      store,
      render: (h) => h(App)
    }).$mount('#app')
  });
}).catch((error) => {
  // 处理错误情况
  console.log(error);
});

